import { PAYMENT_SCHEDULES } from '@app/utils/constants';
import { AUTO_FILING_STATUSES, AutoFiling } from '@shared/meta-data';

/** California filings that use quarter-based prepayments (eligible for interim reminder rows). */
export function isCaQuarterlyBucketFilingFrequency(
  frequency: AutoFiling['frequency'] | string | undefined | null
): boolean {
  return (
    frequency === PAYMENT_SCHEDULES.QUARTERLY
    || frequency === PAYMENT_SCHEDULES['QUARTERLY-PREPAY']
  );
}

/** Enrolled CA quarterly / quarterly prepay filings where reminders can be turned on/off after onboarding. */
export function canMerchantManageCaPrepaymentRemindersSettings(
  state: Pick<AutoFiling, 'state' | 'frequency' | 'status'> | null | undefined
): boolean {
  if (!state?.state || !state?.frequency || !state?.status) {
    return false;
  }

  const eligibleStatuses: ReadonlyArray<AutoFiling['status']> = [
    AUTO_FILING_STATUSES.PROCESSING,
    AUTO_FILING_STATUSES.ACTIVE,
    AUTO_FILING_STATUSES.REGISTERED,
  ];

  return (
    state.state === 'CA'
    && isCaQuarterlyBucketFilingFrequency(state.frequency)
    && eligibleStatuses.includes(state.status)
  );
}
